import InteriorPreview from './InteriorPreview';
export default InteriorPreview;